import {
  Bot,
  FilePen,
  FilePlus,
  FileText,
  Folder,
  FolderSearch,
  Globe,
  ListChecks,
  MessageCircleQuestion,
  Plug,
  Search,
  Sparkles,
  SquareTerminal,
  Wrench,
  type LucideIcon,
} from "lucide-react";

/**
 * Glyph for a harness tool by name. Harness tools report no platform, so the
 * legacy ToolCallIcon would fall through to its generic search glyph for every
 * one of them; this maps the three harnesses' vocabularies (PascalCase for
 * Claude Code, lowercase for OpenCode, snake_case for Codex) onto one set.
 */
export function harnessToolGlyph(toolName: string): LucideIcon {
  if (toolName.startsWith("mcp__")) return Plug;
  switch (toolName.toLowerCase().replace(/_/g, "")) {
    case "read":
    case "readfile":
      return FileText;
    case "write":
    case "writefile":
      return FilePlus;
    case "edit":
    case "multiedit":
    case "notebookedit":
    case "applypatch":
      return FilePen;
    case "bash":
    case "shell":
    case "execcommand":
      return SquareTerminal;
    case "grep":
      return Search;
    case "glob":
      return FolderSearch;
    case "ls":
    case "list":
      return Folder;
    case "task":
    case "agent":
      return Bot;
    case "webfetch":
    case "websearch":
      return Globe;
    case "todowrite":
    case "todoread":
    case "updateplan":
      return ListChecks;
    case "askuserquestion":
      return MessageCircleQuestion;
    case "skill":
      return Sparkles;
    default:
      return Wrench;
  }
}

export function HarnessToolIcon({ toolName }: { toolName: string }) {
  const Glyph = harnessToolGlyph(toolName);
  return <Glyph className="size-[18px] text-n-80" />;
}
